import React from 'react';
import {
  ImageWrapper,
  Overlay,
  StyledButton,
  StyledCenterDiv,
  StyledImage,
  StyledPaper,
  StyledTypo,
} from '../Home.styled';
import useHandleClickFavourites from '../../shared/hooks/useHandleClickFavourites';
import STREAMING from '../../../assets/STREAMING.jfif';

const AttractionSection: React.FC = () => {
  const { resetTeams: resetFavourites } = useHandleClickFavourites();
  return (
    <StyledPaper>
      <ImageWrapper>
        <StyledImage src={STREAMING} alt="Football image" />
        <Overlay />
      </ImageWrapper>
      <StyledCenterDiv>
        <StyledTypo variant="h1">Stream More, Worry Less.</StyledTypo> <br />
        <StyledTypo variant="h4">
          Find your best streaming combination!
        </StyledTypo>
        <StyledButton
          href="/favouriteselection"
          variant="contained"
          size="large"
          onClick={resetFavourites}
        >
          Start a new comparison
        </StyledButton>
      </StyledCenterDiv>
    </StyledPaper>
  );
};
export default AttractionSection;
